// features/admin/adminCouponUsersApi.ts
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export interface CouponUser {
  id: number;
  selected_at: string;
  coupon_id: number;
  order_id: number | null;
  user_id: number;
  first_name: string;
  last_name: string;
  user_email: string;
  user_contact: string;
  code: string;
  discount_type: string;
  discount_value: string;
  max_discount: string;
  start_date: string;
  end_date: string;
  status: number;
}

export interface AdminCouponUsersResponse {
  error: boolean;
  data: CouponUser[];
}

export const STATUS_OPTIONS = [
  { value: 0, label: 'Inactive' },
  { value: 1, label: 'Active' },
];

export const DISCOUNT_TYPE_OPTIONS = [
  { value: 'percentage', label: 'Percentage' },
  { value: 'fixed', label: 'Fixed Amount' },
];

export const adminCouponUsersApi = createApi({
  reducerPath: 'adminCouponUsersApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_SERVER_ENDPOINT,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('admin_token');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      headers.set('authkey', '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3');
      headers.set('Content-Type', 'application/x-www-form-urlencoded');
      return headers;
    },
  }),
  tagTypes: ['AdminCouponUsers'],
  endpoints: (build) => ({
    listAdminCouponUsers: build.query<AdminCouponUsersResponse, void>({
      query: () => ({
        url: 'user/admincoupons-users',
        method: 'POST',
        body: new URLSearchParams(),
      }),
      providesTags: ['AdminCouponUsers'],
      transformResponse: (response: any) => ({
        error: response.error || false,
        data: response.data || [],
      }),
    }),
  }),
});

export const {
  useListAdminCouponUsersQuery,
} = adminCouponUsersApi;